import { render } from "./Chromosome.vue?vue&type=template&id=d49bdc0e&scoped=true"
import script from "./Chromosome.vue?vue&type=script&lang=js"
export * from "./Chromosome.vue?vue&type=script&lang=js"

import "./Chromosome.vue?vue&type=style&index=0&id=d49bdc0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d49bdc0e"]])

export default __exports__